var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoto(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 25,
    viewBox: "0 0 19 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25302 0H11.6074L18.6837 7.38265V21.7255C18.6837 23.521 17.2262 24.9785 15.4307 24.9785H3.25302C1.45752 24.9785 0 23.521 0 21.7255V3.25302C0 1.45752 1.45752 0 3.25302 0Z",
    fill: "#03989E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.302,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5959 0V7.31928H18.6828L11.5959 0Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5147 12.484H6.1671C5.69184 12.484 5.30103 12.8748 5.30103 13.3501V17.3847C5.30103 17.8599 5.69181 18.2507 6.1671 18.2507H12.5147C12.99 18.2507 13.3702 17.86 13.3702 17.3847V13.3501C13.3702 12.8748 12.99 12.484 12.5147 12.484ZM7.89923 13.5719C8.41676 13.5719 8.82865 13.9943 8.82865 14.5013C8.82865 15.0188 8.41676 15.4413 7.89923 15.4413C7.3817 15.4413 6.95924 15.0188 6.95924 14.5013C6.95924 13.9943 7.3817 13.5719 7.89923 13.5719ZM12.7999 17.3847C12.7999 17.5431 12.6731 17.6804 12.5147 17.6804H6.1671C6.00867 17.6804 5.88192 17.5431 5.88192 17.3847V17.2157L7.03315 16.0645L7.98372 17.015C8.09989 17.1312 8.27944 17.1312 8.39561 17.015L10.7826 14.6281L12.7999 16.6454V17.3847Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/Photo.05f484b7b6f5bcde90c4c95e894b2380.svg";
export { ForwardRef as ReactComponent };